export class OverrideEnvironmentResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "environment",
            "baseName": "environment",
            "type": "Environment",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OverrideEnvironmentResponse.attributeTypeMap;
    }
    constructor() {
    }
}
